import { TakePaymentModal, TakePaymentModalByPmsId } from "./CreateTakePaymentModals";
import { show } from "@ebay/nice-modal-react";

/** Display the Take a Payment modal dialog. */
export async function showTakePaymentModal(pmsId?: string) {
    if (!pmsId) {
        await show(TakePaymentModal);
    } else {
        await show(TakePaymentModalByPmsId, { pmsId });
    }
}
